module.exports = __webpack_public_path__ + "static/img/logoPonce.e1379bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoPonce.png
// module id = 738
// module chunks = 10